import React from "react";
import { WraperContainer } from './styles';

export const GridContainer = ({ children, ...props }) => {
    return <WraperContainer {...props}>{children}</WraperContainer>;
};
